import {
  RegularBenefitVariant,
  ShippingApplyTo,
} from '../../../../../../../typings'

export const EMPTY_MAX_SHIPPING = {
  type: RegularBenefitVariant.MaxShipping as const,
  value: undefined,
  applyTo: ShippingApplyTo.all,
}
